export default "__VITE_ASSET__vDqJtyGW__"